
import { Brand } from '~/plugins/config/Brand'
import { Feature } from '~/plugins/engagement/constants'

export default {
  data() {
    return {
      isInteracted: this.$engagement.feature.isInteracted(
        Feature.AIR_TECHNIQUES_REBRAND
      )
    }
  },
  computed: {
    isAirTechniques() {
      return this.$envConfig.branding === Brand.AirTechniques
    },
    show() {
      return this.isAirTechniques && !this.isInteracted
    }
  },
  methods: {
    onClose() {
      this.isInteracted = true
      this.$engagement.feature.markInteracted(Feature.AIR_TECHNIQUES_REBRAND)
    }
  }
}
